<template>
  <div class="w-1/4 px-2">
    <div class="shadow shadow-indigo-600 rounded-md p-5 bg-white">
      <div class="flex items-center justify-between">
        <h3 class="font-bold">{{ $lang.app.CONTACTS_DATA }}</h3>
        <button v-if="currentTab === 'DETAIL'"
                type="button"
                class="bg-indigo-700 rounded-md py-1 text-sm px-2 text-white focus:outline-none hover:shadow-lg"
                :title="$lang.app.EDIT"
                @click="currentTab = 'EDIT'">
          <PencilIcon class="w-4 h-4 inline"/>
        </button>
        <button v-if="currentTab === 'EDIT'"
                type="button"
                class="bg-indigo-700 rounded-md py-1 text-sm px-2 text-white focus:outline-none hover:shadow-lg"
                :title="$lang.app.BACK"
                @click="currentTab = 'DETAIL'">
          <ArrowLeftIcon class="w-4 h-4 inline"/>
        </button>
      </div>
      <Detail v-if="currentTab === 'DETAIL'"
              :user-type="userType"
              :contact-detail="contactDetail"/>
      <Edit v-if="currentTab === 'EDIT'"
            :profile-id="profileId"
            :user-type="userType"
            :contact-detail="contactDetail"/>
    </div>
  </div>
</template>
<script>
import Detail from "./Detail";
import Edit from "./Edit";

export default {
  props: {
    profileId: Number,
    userType: Number,
    contactDetail: Object
  },
  components: {
    Detail,
    Edit,
  },
  data() {
    return {
      currentTab: 'DETAIL',
    }
  },
}
</script>